import { createSlice } from '@reduxjs/toolkit';

import {
    FETCH_USERS,
    FETCH_USERS_FAILURE,
    FETCH_USERS_SUCCESS,
    INITIALIZE_FORM,
    OPEN_MODAL_PASSWORD,
    OPEN_MODAL_PRODUCT,
    RESET,
    RESET_FORM,
    RESTART_PASSWORD,
    RESTART_PASSWORD_FAILURE,
    RESTART_PASSWORD_SUCCESS,
    SAVE_ITEM,
    SAVE_ITEM_FAILURE,
    SAVE_ITEM_SUCCESS,
    SET_IS_NEW_RECORD,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    fetchUsers: {
        data: {
            data: [],
            pagination: null,
        },
        errors: [],
        isFetching: false,
    },
    initialValues: {
        confirm_password: '',
        email: '',
        first_name: '',
        id: null,
        is_enabled: true,
        isOwner: false,
        last_name: '',
        password: '',
        phone: '',
    },
    isOpenModalProduct: false,
    isOpenModalPassword: false,
    isNewRecord: true,
    saveItem: {
        isSaving: false,
        data: {},
        errors: [],
    },
};

const companyUsersSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [FETCH_USERS]: (state) => {
            state.fetchUsers = {
                ...state.fetchUsers,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_USERS_FAILURE]: (state, action) => {
            state.fetchUsers = {
                ...state.fetchUsers,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_USERS_SUCCESS]: (state, action) => {
            state.fetchUsers = {
                ...state.fetchUsers,
                data: action.payload,
                isFetching: false,
            };
        },
        [INITIALIZE_FORM]: (state, action) => {
            state.initialValues = { ...state.initialValues, ...action.payload };
        },
        [OPEN_MODAL_PASSWORD]: (state, action) => {
            state.isOpenModalPassword = action.payload;
        },
        [OPEN_MODAL_PRODUCT]: (state, action) => {
            state.isOpenModalProduct = action.payload;
        },
        [RESET]: () => INITIAL_STATE,
        [RESET_FORM]: (state) => {
            state.initialValues = INITIAL_STATE.initialValues;
        },
        [RESTART_PASSWORD]: (state) => {
            state.saveItem = { ...state.saveItem, errors: [], isSaving: true };
        },
        [RESTART_PASSWORD_FAILURE]: (state, action) => {
            state.saveItem = {
                ...state.saveItem,
                errors: action.payload,
                isSaving: false,
            };
        },
        [RESTART_PASSWORD_SUCCESS]: (state) => {
            state.saveItem.isSaving = false;
        },
        [SAVE_ITEM]: (state) => {
            state.saveItem = { ...state.saveItem, errors: [], isSaving: true };
        },
        [SAVE_ITEM_FAILURE]: (state, action) => {
            state.saveItem = {
                ...state.saveItem,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_ITEM_SUCCESS]: (state, action) => {
            state.saveItem = {
                ...state.saveItem,
                data: action.payload,
                isSaving: false,
            };
        },
        [SET_IS_NEW_RECORD]: (state, action) => {
            state.isNewRecord = action.payload;
        },
    },
});

export const companyUsersActions = companyUsersSlice.actions;

export default companyUsersSlice.reducer;
